import { SatsangSevakGroup, satsangSevakRows } from "~/interface/satsng-sevak-types/satsang-sevak";

export const getSatsangSevakGroupData = (satsangSevakData: satsangSevakRows[]): SatsangSevakGroup => {
  const grouped: SatsangSevakGroup = satsangSevakData.reduce((acc, data) => {
    if (!acc[data.year]) {
      acc[data.year] = [];
    }
    acc[data.year].push(data);
    return acc;
  }, {} as SatsangSevakGroup);

  // //Sort the year in descending order
  const sortedYears = Object.keys(grouped).sort((a, b) => (a < b ? 1 : -1));

  //create a new object with sorted year keys as number
  const sortedGrouped: SatsangSevakGroup = {};
  for (const year of sortedYears) {
    sortedGrouped[Number(year)] = grouped[Number(year)];
  }
  return sortedGrouped;
};
